export default __webpack_public_path__ + "static/media/icon_file_24_Regular.117c709a.svg";